function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.object.define-properties.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { themesMixin } from '../utils/themes';
import { mapActions, mapState, mapMutations } from 'vuex';
export default {
  name: 'ViewLogin',
  directives: {
    disabledIconFocus: {
      bind: function bind(el) {
        el.querySelectorAll('.v-input__icon button').forEach(function (x) {
          return x.setAttribute('tabindex', -1);
        });
      }
    }
  },
  mixins: [themesMixin],
  data: function data() {
    return {
      showPage: false,
      valid: false,
      email: '',
      password: '',
      marker: false,
      tenantName: null,
      emailRules: [function (v) {
        return !!v;
      }, function (v) {
        return /.+@.+\..+/.test(v);
      }],
      passwordRules: [function (v) {
        return !!v;
      }],
      submitted: false,
      homeRedirect: '/home',
      responsive: false,
      responsiveInput: false,
      showMfaInput: false,
      mfaToken: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'CustomTheme', 'UiTheme', 'loading'])), {}, {
    loginLogo: function loginLogo() {
      return this.themeGetLogoObject();
    },
    logoDefaultJustify: function logoDefaultJustify() {
      if (this.logoPosition() === 'right') {
        return 'end';
      }
      if (this.logoPosition() === 'center') {
        return 'center';
      }
      return 'start';
    },
    loginLogoCenteredStyle: function loginLogoCenteredStyle() {
      if (this.isDefaultSvgLogo()) {
        return 'width: 134px; height: 40px;';
      }
      return "padding: 5px; width: ".concat(this.loginLogo.orientation === 'square' ? 120 : 210, "px; height: 120px;");
    },
    loginBackground: function loginBackground() {
      return this.themeGetBackground();
    },
    redirect: function redirect() {
      if (this.$route.query.redirect) {
        return this.$route.query.redirect;
      }
      return null;
    },
    isOauth: function isOauth() {
      return this.$route.query.oauth ? true : false;
    },
    oauthSubdomainRedirectHref: function oauthSubdomainRedirectHref() {
      var host = window.location.hostname;
      var href = window.location.href;
      var lastLoginSubdomain = localStorage.getItem('lastLoginSubdomain');
      if (lastLoginSubdomain && lastLoginSubdomain !== host) {
        var url = href.replace(host, lastLoginSubdomain);
        return url;
      }
      return null;
    }
  }),
  mounted: function mounted() {
    var _this = this;
    // first attempt of loading, should have requested correct theming by now
    this.homeRedirect = this.$store.state.app.sidebarIconLink || '/home';
    document.getElementsByTagName('html')[0].classList.add('hide__scrollbar');
    if (this.isOauth && this.oauthSubdomainRedirectHref) {
      window.location.href = this.oauthSubdomainRedirectHref;
      return;
    }
    if (this.$route.query.token) {
      this.loginWithToken(this.$route.query.token).then(function () {
        _this.$router.push(_this.homeRedirect);
      })["catch"](function (error) {
        _this.showPage = true;
        if (error.response && _this["this"].$i18n_t("Error.".concat(error.response.data.message))) {
          _this.$snack(_this.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this.$snack(_this.$i18n_t('Common.oauthTokenError'), 'error');
        }
      });
    } else if (this.$route.query.error) {
      this.showPage = true;
      switch (this.$route.query.error) {
        case 'oauth_user':
          this.$snack(this.$i18n_t('Common.errorOauthUserNotFound'), 'error');
          break;
      }
    } else {
      this.verify().then(function () {
        if (_this.isOauth && _this.redirect) {
          window.location.href = "".concat(_this.redirect, "&token=").concat(localStorage.getItem('token'));
          return;
        }
        _this.$snack(_this.$i18n_t('Common.welcomeBack'), 'success');
        _this.$router.push(_this.homeRedirect);
      })["catch"](function () {
        // Do nothing
        _this.showPage = true;
      });
    }
    this.onResponsiveInverted();
    window.addEventListener('resize', this.onResponsiveInverted);
  },
  beforeDestroy: function beforeDestroy() {
    document.getElementsByTagName('html')[0].classList.remove('hide__scrollbar');
    window.removeEventListener('resize', this.onResponsiveInverted);
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions('authentication', ['login', 'loginWithToken', 'verify'])), mapMutations('app', ['snackbar'])), {}, {
    validate: function validate() {
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        this.snackbar = true;
      }
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;
      // for double good measure, re-load the sidebar-home-link here, if it exists
      this.homeRedirect = this.$store.state.app.sidebarIconLink || '/home';
      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      this.validate();
      this.submitted = true;
      var email = this.email,
        password = this.password,
        mfaToken = this.mfaToken,
        $router = this.$router;
      this.login(_objectSpread(_objectSpread({}, {
        username: email,
        password: password
      }), mfaToken && {
        token: mfaToken
      })).then(function () {
        _this2.$snack(_this2.$i18n_t('Common.loggedIn'), 'success');
        _this2.$store.state.app.load = 100;
        _this2.$store.state.app.loading = false;
        if (_this2.isOauth && _this2.redirect) {
          window.location.href = "".concat(_this2.redirect, "&token=").concat(localStorage.getItem('token'));
          return;
        }
        if (_this2.redirect) {
          $router.push(_this2.redirect);
          return;
        }
        $router.push(_this2.homeRedirect);
      })["catch"](function (error) {
        _this2.$store.state.app.load = 100;
        _this2.$store.state.app.loading = false;
        if (error.data && error.data.message === '2FA_TOKEN_REQUIRED') {
          _this2.showMfaInput = true;
          return;
        } else if (error.data && _this2.$i18n_t("Error.".concat(error.data.message))) {
          _this2.$snack(_this2.$i18n_t("Error.".concat(error.data.message)), 'error');
        } else if (error.data && !_this2.$i18n_t("Error.".concat(error.data.message))) {
          _this2.$snack(_this2.$i18n_t('Error.unknown'), 'error');
        } else {
          _this2.$snack(_this2.$i18n_t('Common.credWrong'), 'error');
        }
      });
    },
    onResponsiveInverted: function onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
        this.responsiveInput = false;
      } else {
        this.responsive = false;
        this.responsiveInput = true;
      }
    }
  })
};